import React from "react"
import { Controller } from "react-hook-form"
import { newsTags } from "../../../api/Definitions"
import DateInput from "../../../components/Form/Inputs/DateInput"
import FormInput from "../../../components/Form/Inputs/FormInput"
import Textarea from "../../../components/Form/Inputs/Textarea"
import SelectInput from "../../../components/Form/Select/Select"

const NewsOverview = () => {
  return (
    <div className="scrollable">
      <FormInput name="pretitle" label="Pretitle" />
      <FormInput name="title" label="Title" />
      <FormInput name="subtitle" label="Subtitle" />
      <Controller
        as={Textarea}
        name="shortDescription"
        label="Short description"
      />
      <Controller as={DateInput} name="date" showYearDropdown label="Date" />
      <Controller
        as={SelectInput}
        name="tag"
        options={newsTags}
        label="Tags"
        isClearable
        isMulti
      />
      <FormInput
        name="link"
        label="Link"
        placeholder="Enter Link for News"
        validation={{
          pattern: {
            value: /^((http|https):\/\/).+$/,
            message: "Link must start with http:// or https://",
          },
        }}
      />
      <FormInput
        name="priority"
        label="Priority (0 - Highest)"
        placeholder="Set priority"
        validation={{
          pattern: {
            value: /^\d+$/,
            message: "Priority must be number",
          },
        }}
      />
    </div>
  )
}

export default NewsOverview
